<template>
  <div class="m-wrap m-pc">
    <Logo />
    <Banner />
    <div class="wrap-info">
      <div class="over-box" v-if="isTrackClosedMessage">
        <FormStatus :status="'over'" :platform="platform"></FormStatus>
        <div class="bottom">
          <a-button
            class="btn-default"
            v-show="formInfo.identity == 1"
            v-if="extraItem.extras('signupfont.model').length > 0"
            @click="togoVerify()"
          >
            {{ extras | extra("signupfont.model") }}
          </a-button>
        </div>
      </div>
      <div
        v-else-if="preview || formInfo.status == 1"
        :class="
          extraItem.extras('activityTheme.display') == 1 ||
          extraItem.extras('activityTime.display') == 1 ||
          extraItem.extras('activityPlace.display') == 1 ||
          extraItem.extras('activitySchedule.display') == 1
            ? 'form-info'
            : 'form-info-width'
        "
      >
        <h4
          class="title"
          :style="{
            color: extraItem.extras('titlefont.color'),
            fontSize: pxOrVw(extraItem.extras('titlefont.size')),
            fontWeight:
              extraItem.extras('titlefont.weight') == 'default'
                ? '500'
                : extraItem.extras('titlefont.weight'),
          }"
          v-if="extraItem.extras('titlefont.display') == 1"
        >
          {{ formInfo.title }}
        </h4>
        <LangSelector />
        <CField
          class="field-wrap"
          :formData="formData"
          :platform="platform"
          :rulesJump.sync="rulesJump"
          ref="formRef"
        />
        <div v-if="preview || formInfo.status == 1">
          <div class="split-line"></div>
          <div class="bottom">
            <a-button
              class="submit"
              type="primary"
              @click="submit()"
              :disabled="isSubmitting"
            >
              {{ extras | extra("submitfont.model") }}
            </a-button>
            <a-button
              class="btn-default"
              v-show="formInfo.identity == 1"
              v-if="extraItem.extras('signupfont.model').length > 0"
              @click="togoVerify()"
            >
              {{ extras | extra("signupfont.model") }}
            </a-button>
          </div>
        </div>
      </div>

      <FormStatus
        v-else
        :status="formInfo.status == 0 ? 'nostart' : 'over'"
        :platform="platform"
      ></FormStatus>

      <Meeting :seminarInfo="seminarInfo" />
      <Card :tenantId="tenantId"></Card>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/Logo.vue";
import Banner from "@/components/Banner.vue";
import CField from "@/components/CField.vue";
import FormStatus from "@/components/FormStatus.vue";
import Meeting from "@/components/Meeting.vue";
import LangSelector from "@/components/LangSelector.vue";
import mixinConfig from "../../mixin/config.js";
import mixinMeeting from "../../mixin/meeting.js";
import mixin from "../../mixin/form.js";
import i18nMixin from "../../mixin/i18n.js";
import Card from "../../../stempcore/src/core/components/common/Card";
export default {
  name: "PcIndex",
  mixins: [mixinConfig, mixinMeeting, mixin, i18nMixin],
  components: {
    Logo,
    Banner,
    CField,
    FormStatus,
    Meeting,
    LangSelector,
    Card,
  },
  data() {
    return {
      platform: "pc",
    };
  },
};
</script>
